import Cookies from 'js-cookie'

const bar = document.querySelector('#top-alert-message');
const button = document.querySelector('#top-alert-message button[data-bs-dismiss]');
const cookieName = 'site-alert-dismissed';
const cookieId = bar.getAttribute('data-cachebuster');

button.addEventListener('click', () => {
    Cookies.set(cookieName, cookieId, true, { expires: 1 });
})